/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import GenericTable from "../../components/GenericTable";
import { Button, Checkbox, Col, Form, Input, Radio } from "antd";
import { escapeRegExp } from "lodash";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import GenericSelector from "../../components/GenericSelector";
import DateTimePicker from "../../components/DateTimePicker";
import { Row } from "antd/es/grid";
import TableLineIcons from "../../components/TableLineIcons";
import moment from "moment";


class PosConnectedDevices extends Component {
    constructor(props/*: Props*/) {
        super(props);
        this.defFilters = {
            _sort_by: "col_3",
            _posList: "",
            _branchList: "",
            _type: null,
            _ip: "",
            _mac: "",
            _fromModificationDate: null,
            _toModificationDate: null,
            _isActive: '1',
        }
        this.state = {
            modalFilter: false,
            modalMac: null,
            filters: this.defFilters,
        }

        this.id = "POS_CONNECTED_DEVICES";
        this.mac_id = "POS_CONNECTED_DEVICES_MAC";

        this.api = {
            get: "get_pos_connected_devices",
            edit: "edit_pos_connected_devices",
        }

        this.selectors = [
            { id: "DEVICE_TYPES_LIST", api: "device_types_list" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[this.mac_id] === undefined) props.data[this.mac_id] = { ...props.data.genericData };
        this.selectors.forEach((x) => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate(p) {
        if (p.posFilter !== this.props.posFilter) {
            this.setState({ filters: { ...this.defFilters, _posList: this.props.posFilter ?? "" } }, this.onFilter)
        }
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    refreshDataMac = () => {
        this.props.dataActions.genericDataGetRequested(this.mac_id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    showsearch = (val) => {
        this.props.dataActions.genericDataSetFilter(
            this.id,
            this.props.user.companyCode,
            this.props.user.token,
            { ...this.props.data[this.id].filters, page: 1, _page_num: 1, _words: escapeRegExp(val) },
            this.api.get);
    }

    onFilter = () => {
        this.props.dataActions.genericDataSetFilter(
            this.id,
            this.props.user.companyCode,
            this.props.user.token,
            { ...this.props.data[this.id].filters, page: 1, _page_num: 1, ...this.state.filters },
            this.api.get);
        this.setState({ modalFilter: false })
    }

    filterField = (label, field) => {
        const value = this.state.filters[field]
        const onChange = e => { this.setState({ filters: { ...this.state.filters, [field]: e } }) }
        const formItem = c => (<Form.Item label={label}>{c}</Form.Item>)
        const multiSelectParams = { multi: true, value: value ? value.split(",") : [], onChange: e => { onChange(e ? e.join(",") : "") } }

        switch (field) {
            case '_posList': return formItem(<GenericSelectorPosStorages {...this.props} {...multiSelectParams} />)
            case '_branchList': return formItem(<GenericSelectorBranches {...this.props} {...multiSelectParams} />)
            case '_type': return formItem(<GenericSelector {...this.props} {...this.selectors[0]} addFirstRow={{ code: "0", name: " - " }} {...{ value, onChange }} />)
            case '_ip': case '_mac': return formItem(<Input value={value} onChange={e => { onChange(e.target.value) }} />)
            case '_fromModificationDate': case '_toModificationDate': return formItem(<DateTimePicker format="DD/MM/YYYY" {...{ value, onChange }} />)
            case '_isActive': return formItem(<Radio.Group value={value} onChange={e => { onChange(e.target.value) }}>
                <Radio value={"-1"}>{this.getText(21073)}</Radio>
                <Radio value={"1"}>{this.getText(21074)}</Radio>
                <Radio value={"0"}>{this.getText(21075)}</Radio>
            </Radio.Group>)
        }
    }

    render() {
        const gt = this.getText;
        const sorter = true
        const { editing, editedRecord } = this.props.data[this.id]
        const render = t => t
        const renderDatetime = t => t ? moment(t).format("DD/MM/YYYY HH:mm") : ""
        const renderPos = (t, r) => `${t} - ${r.dPosName}`
        const renderBranch = (t, r) => `${t} - ${r.dBranchName}`
        const renderType = (t, r) => `${t} - ${r.dTypeName}`
        const renderDesc = (t, r) => r.key === editing ? (<Input value={editedRecord.dDesc} onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { dDesc: e.target.value }) }} />) : t
        const renderActive = t => (<Checkbox checked={t == 1} disabled />)
        const renderEdit = (t, r) => r.key === editing ? (<TableLineIcons
            onCheck={() => { this.props.dataActions.genericDataSaveEdit(this.id, this.props.user.companyCode, this.props.user.token, this.api.edit, this.api.get) }}
            onClose={() => { this.props.dataActions.genericDataCancelEditing(this.id) }}
        />) : (<TableLineIcons
            onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, r.key, r.index) }}
            genericIcons={[{ type: "eye", onClick: () => { this.setState({ modalMac: r }) }, tooltip: gt(21076) }]}
        />)

        const columns = this.props.posFilter ? [
            { title: gt(21046), key: 'dID', dataIndex: 'dID', width: "8%", sorter, render },
            { title: gt(21049), key: 'dTypeId', dataIndex: 'dTypeId', width: "18%", sorter, render: renderType },
            { title: gt(21050), key: 'dIp', dataIndex: 'dIp', width: "18%", sorter, render },
            { title: gt(21051), key: 'dMac', dataIndex: 'dMac', width: "18%", sorter, render },
            { title: gt(21052), key: 'dDesc', dataIndex: 'dDesc', width: "30%", sorter, render: renderDesc },
            { title: gt(21054), width: "8%", render: renderEdit },
        ] : [
            { title: gt(21046), key: 'dID', dataIndex: 'dID', width: "6%", sorter, render },
            { title: gt(21047), key: 'dPosId', dataIndex: 'dPosId', width: "12%", sorter, render: renderPos },
            { title: gt(21048), key: 'dBranchId', dataIndex: 'dBranchId', width: "12%", sorter, render: renderBranch },
            { title: gt(21049), key: 'dTypeId', dataIndex: 'dTypeId', width: "12%", sorter, render: renderType },
            { title: gt(21050), key: 'dIp', dataIndex: 'dIp', width: "12%", sorter, render },
            { title: gt(21051), key: 'dMac', dataIndex: 'dMac', width: "12%", sorter, render },
            { title: gt(21052), key: 'dDesc', dataIndex: 'dDesc', width: "22%", sorter, render: renderDesc },
            { title: gt(21053), key: 'dIsActive', dataIndex: 'dIsActive', width: "6%", sorter, render: renderActive },
            { title: gt(21054), width: "6%", render: renderEdit },
        ]

        let actionButtons = [{
            buttonType: 'refresh',
            buttonFunction: this.refreshData
        }]

        if (!this.props.posFilter) {
            actionButtons = [
                ...actionButtons,
                {
                    buttonType: 'filter',
                    buttonFunction: () => { this.setState({ modalFilter: true }) }
                }]
        }

        return (<GenericModal {...this.props}
            title={gt(21045)}
            showsearch={this.showsearch}
            actionButtons={actionButtons}>

            <GenericTable {...this.props}
                id={this.id}
                getApi={this.api.get}
                tableOnly
                filters={this.state.filters}
                columns={columns} />

            <GenericModal
                visible={this.state.modalFilter}
                onCancel={() => { this.setState({ modalFilter: false, filters: this.props.data[this.id].filters }) }}
                width={1200}
                title={gt(21055)}
                footer={[
                    <Button key="back" onClick={() => { this.setState({ modalFilter: false, filters: this.props.data[this.id].filters }) }}>{gt(21056)}</Button>,
                    <Button key="clear" onClick={() => { this.setState({ filters: this.defFilters }, this.onFilter) }}>{gt(21057)}</Button>,
                    <Button key="create" type="primary" onClick={this.onFilter}>{gt(21058)}</Button>,
                ]}>
                <Row>
                    <Col span={window.innerWidth < 600 ? 24 : 12} style={{ padding: 10 }}>
                        {this.filterField(gt(21059), "_posList")}
                        {this.filterField(gt(21060), "_branchList")}
                        {this.filterField(gt(21061), "_type")}
                    </Col>
                    <Col span={window.innerWidth < 600 ? 24 : 12} style={{ padding: 10 }}>
                        {this.filterField(gt(21062), "_ip")}
                        {this.filterField(gt(21063), "_mac")}
                        <Row>
                            <Col span={12}>{this.filterField(gt(21064), "_fromModificationDate")}</Col>
                            <Col span={12}>{this.filterField(gt(21065), "_toModificationDate")}</Col>
                        </Row>
                        {this.filterField(gt(21066), "_isActive")}
                    </Col>
                </Row>
            </GenericModal>

            <GenericModal
                visible={this.state.modalMac != null}
                onCancel={() => { this.setState({ modalMac: null }) }}
                title={<span>{this.state.modalMac?.dTypeName} - {this.state.modalMac?.dMac}</span>}
                width={1200}
                actionButtons={[{
                    buttonType: 'refresh',
                    buttonFunction: this.refreshDataMac
                }]}
                footer={[
                    <Button type="primary" onClick={() => { this.setState({ modalMac: null }) }}>{gt(21077)}</Button>,
                ]}>
                {this.state.modalMac ?
                    <GenericTable {...this.props}
                        id={this.mac_id}
                        getApi={this.api.get}
                        tableOnly
                        filters={{
                            ...this.defFilters,
                            _sort_by: "col_1",
                            _isAsc: 0,
                            _mac: this.state.modalMac.dMac,
                            _isActive: -1,
                            _posList: this.props.posFilter ?? "", 
                        }}
                        columns={[
                            { title: gt(21046), key: 'dID', dataIndex: 'dID', width: "8%", sorter, render },
                            { title: gt(21047), key: 'dPosId', dataIndex: 'dPosId', width: "13%", sorter, render: renderPos },
                            { title: gt(21048), key: 'dBranchId', dataIndex: 'dBranchId', width: "13%", sorter, render: renderBranch },
                            { title: gt(21050), key: 'dIp', dataIndex: 'dIp', width: "13%", sorter, render },
                            { title: gt(21052), key: 'dDesc', dataIndex: 'dDesc', width: "25%", sorter, render: renderDesc },
                            { title: gt(21053), key: 'dIsActive', dataIndex: 'dIsActive', width: "8%", sorter, render: renderActive },
                            { title: gt(21078), key: 'dModificationTimeStamp', dataIndex: 'dModificationTimeStamp', width: "20%", sorter, render: renderDatetime },
                        ]} />
                    : ""}
            </GenericModal>

        </GenericModal>)
    }
}

export default PosConnectedDevices;